import {
  getAllCategoryAndSubcategoryIds,
  resolveActiveCategoryIdsFromDatabase,
  type ActiveCategoryIds,
} from "@/lib/categories/categoryActivationState";

export type { ActiveCategoryIds };
export { resolveActiveCategoryIdsFromDatabase };

export function getAllActiveCategoryIdsFromCode(): ActiveCategoryIds {
  const { categoryIds, subcategoryIds } = getAllCategoryAndSubcategoryIds();
  return { categories: categoryIds, subcategories: subcategoryIds };
}
